import { render, staticRenderFns } from "./ShareMapWx.vue?vue&type=template&id=45d0abce&scoped=true&lang=html"
import script from "./ShareMapWx.vue?vue&type=script&lang=js"
export * from "./ShareMapWx.vue?vue&type=script&lang=js"
import style0 from "./ShareMapWx.vue?vue&type=style&index=0&id=45d0abce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d0abce",
  null
  
)

export default component.exports